import React from 'react';
import { Link } from 'react-router-dom';
import StrokedText from '../../Participation/Nodes/StrokedText';
import ScoreFill from './ScoreFill';
import OrgTreeWeightBadge, {
  ORG_TREE_WEIGHT_ICON_SIZE,
} from './OrgTreeWeightBadge';

const TeamNode = ({
  radius,
  showWeights,
  workspaceId,
  assessmentKey,
  node: {
    x: y,
    y: x,
    data: { id, name, score, weight },
  },
}) => {
  const displayName = name;
  const scoreIsValid = typeof score === 'number' && !isNaN(score);
  const { wrapperProps, wrapperComponent: Wrapper } = scoreIsValid
    ? {
        wrapperProps: {
          to: `/w/${workspaceId}/teams/${id}/assessments/${assessmentKey}`,
        },
        wrapperComponent: Link,
      }
    : { wrapperProps: {}, wrapperComponent: React.Fragment };

  const weightTransform = `translate(${-(
    radius +
    ORG_TREE_WEIGHT_ICON_SIZE +
    6
  )}, ${-ORG_TREE_WEIGHT_ICON_SIZE / 2 + 1})`;

  return (
    <g transform={`translate(${x},${y})`}>
      <ScoreFill radius={radius} score={score} />
      {showWeights ? (
        <OrgTreeWeightBadge weight={weight} transform={weightTransform} />
      ) : null}
      <Wrapper {...wrapperProps}>
        <StrokedText
          strokeWidth={3}
          strokeColor="#2c2c2c"
          textAnchor="start"
          fill="#fff"
          x={radius + 4}
          y={1}
          dominantBaseline="middle"
          className="team-name"
          fontSize={10}
        >
          {displayName}
        </StrokedText>
      </Wrapper>
    </g>
  );
};

export default TeamNode;
